import type { ParentComponent } from "../../lib/types";

const Heading: ParentComponent = ({ children }) => (
	<h2 className="font-sans text-sm leading-[1.6] font-semibold text-foreground not-first:mt-[1lh] not-last:mb-[0.5lh] desktop:text-md">
		{children}
	</h2>
);

export { Heading };
